import { createContext, useContext, useEffect, useState } from "react";
import { useLang } from "./LangContext";

export const USD_TO_IQD = 1310;

const CurrencyContext = createContext();

export function CurrencyProvider({ children }) {
  const { lang } = useLang();
  // Currency now follows language: AR -> IQD, EN -> USD
  const [currency, setCurrency] = useState(() => lang === "ar" ? "IQD" : "USD");

  useEffect(() => {
    setCurrency(lang === "ar" ? "IQD" : "USD");
  }, [lang]);

  const toggle = () => setCurrency((c) => (c === "USD" ? "IQD" : "USD"));

  const fmt = (usd, opts = {}) => {
    const { sign = false, decimals = 2 } = opts;
    const num = Number(usd) || 0;
    if (currency === "IQD") {
      const iqd = Math.round(num * USD_TO_IQD);
      const formatted = iqd.toLocaleString("en-US");
      return `${sign && num > 0 ? "+" : ""}${formatted} د.ع`;
    }
    return `${sign && num > 0 ? "+" : ""}$${num.toFixed(decimals)}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, toggle, fmt, rate: USD_TO_IQD }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
